// extracted by mini-css-extract-plugin
module.exports = {"input":"CbInput_input__z9_vJ"};